<script>
import { inicializarListado, listadoDePuntosDeVenta, listandoPuntosDeVenta, desconectar } from '@/../../cliente_comun/fuentes_puntosDeVenta.js'

const encabezado = [
	{ text: 'Nombre', value: 'nombre', sortable: false },
	{ text: 'Descripción', value: 'descripción', sortable: false },
	{ text: '', value: 'acciones', align: 'end', filterable: false, sortable: false },
]

export default {
	setup(props, { emit }) {
		inicializarListado()

		return {
			listadoDePuntosDeVenta,
			listandoPuntosDeVenta,
			encabezado,
			emit,
		}
	},

	beforeDestroy() {
		desconectar()
	}
}

</script>

<template>
	<v-data-table
		:headers="encabezado"
		:items="listadoDePuntosDeVenta"
		item-key="identificador"
		class="elevation-1 mb-16"
		:items-per-page="10000"
		:loading="listandoPuntosDeVenta"
		hide-default-footer
	>
		<template v-slot:item.nombre="{ item }">
			{{ item.nombre }}
		</template>
		<template v-slot:item.acciones="{ item }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-on="on" v-bind="attrs" @click="emit('editar', item)">
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</template>
				<span>Editar punto de venta</span>
			</v-tooltip>
		</template>
	</v-data-table>
</template>
